import { c as _c } from "react-compiler-runtime";
import { useApolloClient } from '@apollo/client';
import { useDataFetchingClient } from 'data-fetching-client';
import { ViewsManagementProvider } from 'customer-data-views-management/providers/ViewsManagementProvider';
import { mutationFieldPolicies, queryFieldPolicies } from 'customer-data-views-management/providers/fieldPolicies';
import { useAddTypePolicies } from 'marketing-platform-lib/hooks/useAddTypePolicies';

/**
 * This provider ensures that the DFC cache used by customer-data-views-management
 * is shared with the rest of framework-listing-lib.
 *
 * This is necessary for us to be able to reuse hooks from CDVM, like useFetchSingleView and useFetchPinnedViews,
 * outside of the PinnedViewsBar component subtree
 *
 * customer-data-views-management customizes their DFC cache. Requiring all downstream consumers to add a runtime dep
 * on CDVM, import its typePolicies, and add them to their DFC client constructions is unrealistic.
 * Instead we use addTypePolicies to inject them at runtime
 * https://www.apollographql.com/docs/react/caching/cache-configuration#customizing-type-policies
 * This needs to run before any CDVM queries return, or else the typePolicies will be bypassed
 *
 *  See also discussion here: https://git.hubteam.com/HubSpot/data-fetching-client/pull/270
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function PinnedViewsBarClientProvider(props) {
  "use memo";

  const $ = _c(6);
  const dfcClient = useDataFetchingClient();
  const apolloClient = useApolloClient();
  let t0;
  if ($[0] !== dfcClient) {
    t0 = {
      client: dfcClient,
      queryFieldPolicies,
      mutationFieldPolicies
    };
    $[0] = dfcClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useAddTypePolicies(t0);
  const t1 = apolloClient;
  let t2;
  if ($[2] !== dfcClient || $[3] !== props.children || $[4] !== t1) {
    t2 = /*#__PURE__*/_jsx(ViewsManagementProvider, {
      dfcClient: dfcClient,
      apolloClient: t1,
      children: props.children
    });
    $[2] = dfcClient;
    $[3] = props.children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}